import { render, staticRenderFns } from "./HelpTermWarranty.vue?vue&type=template&id=60cbae19"
import script from "./HelpTermWarranty.vue?vue&type=script&lang=js"
export * from "./HelpTermWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports